import React from "react";
import { Modal } from "react-bootstrap";
import moment from 'jalali-moment';


export default class ExamTimeViewModal extends React.PureComponent<{}, { message?: string; showModal: boolean; examId: number; examDateTimeFrom: string, examDateTimeTo: string, examTime: string }>{
    constructor(props: {}) {
        super(props);
        this.state = { examId: 0, showModal: false, examDateTimeFrom: '', examDateTimeTo: '', examTime: '' };
    }

    openModal = (examResultId: number, examDateTimeFrom?: string, examDateTimeTo?: string, examTime?: string, message?: string) => {
        if (message)
            this.setState({ showModal: true, examId: examResultId, message });
        else if (examDateTimeFrom && examDateTimeTo && examTime)
            this.setState({ showModal: true, examId: examResultId, examDateTimeFrom, examDateTimeTo, examTime });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    render(): React.ReactNode {
        let { examDateTimeFrom, examDateTimeTo, examTime, showModal, message } = this.state;
        return (<>
            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label className="font-bold validation-message">بروز خطا</label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="view-exam-result-details-modal">
                    {
                        showModal &&
                        <div className="exam-view-area text-center">
                            <div className="font-bold">
                                آزمون در دسترس نیست
                            </div>
                            {
                                message ? <div className="pt-4">{message}</div> :
                                    <div className="pt-4">
                                        زمان برگزاری آزمون از
                                        <label className="font-bold">{moment(examDateTimeFrom, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</label>
                                        <label style={{ padding: '0 2px' }}> تا </label>
                                        <label className="font-bold">{moment(examDateTimeTo).locale('fa').format('YYYY/MM/DD')}</label>
                                        {
                                            examTime &&
                                            <>
                                                <label style={{ padding: '0 2px' }}>ساعت</label>
                                                <label className="font-bold">{examTime}</label>
                                            </>
                                        }
                                        می باشد.
                                    </div>
                            }
                        </div>
                    }
                </Modal.Body >
                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}